// Set the min attribute of the date input to the current date
document.addEventListener("DOMContentLoaded", (event) => {
  let dateInput = document.getElementById("end");
  dateInput.setAttribute("min", getCurrentDate());
  const form = document.querySelector(".calcForm");
  const aside = document.querySelector(".calculatorResults");
  const formBtn = document.querySelector(".calcSubmit");
  const maintenance = document.querySelector(".calcResultsHead");
  const listBreakdown = document.querySelector(".resultsBreakdownList");
  const warning = document.querySelector(".warning");
  let previousFormData = {};

  formBtn.addEventListener("click", (e) => {
    e.preventDefault();

    const formData = {
      age: form.querySelector("#age").value,
      feet: form.querySelector("#feet").value,
      inches: form.querySelector("#inches").value,
      weight: form.querySelector("#weight").value,
      gender: form.querySelector("#gender").value,
      act: form.querySelector("#activity").value,
      goalWeight: form.querySelector("#goalweight").value,
      endDate: form.querySelector("#end").value,
    };
    const nDate = new Date();
    const curDate = getCurrentDate();

    // Check if the form data has changed
    if (JSON.stringify(formData) === JSON.stringify(previousFormData)) {
      console.log("Data has not changed.");
      return; // Exit early if data hasn't changed
    }

    // Update the previous form data
    previousFormData = { ...formData };
    const daysToCut = daysBetweenDates(curDate, formData.endDate);
    if (daysToCut < 1) {
      showWarning("Choose a date after the current day.");
      return;
    }
    const startBMR = calculateTDEE(
      formData.age,
      heightToInches(formData.feet, formData.inches),
      formData.weight,
      formData.gender
    );
    const endBMR = calculateTDEE(
      formData.age,
      heightToInches(formData.feet, formData.inches),
      formData.goalWeight,
      formData.gender
    );
    const weightDelta = formData.weight - formData.goalWeight;
    const BMRDelta = startBMR - endBMR;
    const totalDeficit = weightDelta * 3500;
    const dailyDeficit = totalDeficit / daysToCut;
    const cut = 30;
    const deficitDelta = maintenance.querySelector("span");
    deficitDelta.innerHTML = "";
    if (weightDelta > 0) {
      // Weight loss
      if (dailyDeficit > startBMR || dailyDeficit > 1500) {
        showWarning(
          "Note: This is an unsafe cut, please choose a heavier end goal, more exercise, or further end date."
        );

        return;
      } else if (dailyDeficit > 1000) {
        showWarning(
          "Note: This is a steep deficit. You will likely lose muscle."
        );
      } else {
        hideWarning();
      }

      const upperLimit = Math.floor(daysToCut / cut);
      listBreakdown.innerHTML = "";
      if (upperLimit === 0) {
        const newLi = document.createElement("li");
        const dailyIntake = startBMR - BMRDelta * 1;
        newLi.innerHTML = `
            <h4>
            Day ${0 * cut + 1}-${1 * daysToCut}
          </h4>
          <p>Eat below <strong>${roundToNearest(
            calculateTotalExpenditure(dailyIntake, formData.act, dailyDeficit)
          )} calories</strong> per day</p>
        `;
        listBreakdown.appendChild(newLi);
      } else {
        for (let i = 0; i <= upperLimit; i++) {
          const newLi = document.createElement("li");
          const percentage = (i + 1) / upperLimit;
          const dailyIntake = startBMR - BMRDelta * percentage;
          newLi.innerHTML = `
        <h4>
          Day ${i * cut + 1}-${i + 1 > upperLimit ? daysToCut : (i + 1) * cut}
          </h4>
          <p>Eat below <strong>${roundToNearest(
            calculateTotalExpenditure(dailyIntake, formData.act, dailyDeficit)
          )} calories</strong> per day</p>
            `;
          listBreakdown.appendChild(newLi);
        }
      }
      deficitDelta.classList.add("red");
      deficitDelta.classList.remove("green");
      deficitDelta.innerHTML = "-" + roundToNearest(Math.trunc(dailyDeficit));
    } else if (weightDelta < 0) {
      // Weight gain
      showWarning("Enter a weight that is less than your current weight");
      return;
    } else if (formData.weight === formData.goalWeight) {
      showWarning(
        "Please enter a goal weight that is different from your current weight."
      );

      return;
    }

    aside.classList.add("active");
  });

  function heightToInches(feet, inches) {
    return Number(feet) * 12 + Number(inches);
  }
  function lbsToKg(pounds) {
    return pounds * 0.453592;
  }
  function roundToNearest(number) {
    return number;
    // return Math.round(number / 25) * 25;
  }
  function inchesToCm(inches) {
    return inches * 2.54;
  }
  function calculateTDEE(age, heightInInches, weightInLbs, gender) {
    let weightInKg = lbsToKg(weightInLbs);

    let heightInCm = inchesToCm(heightInInches);

    let tdee;
    if (gender === "male") {
      tdee = 10 * weightInKg + 6.25 * heightInCm - 5 * age + 5;
    } else {
      tdee = 10 * weightInKg + 6.25 * heightInCm - 5 * age - 161;
    }

    return tdee;
  }
  function showWarning(message) {
    warning.innerHTML = message;
    warning.style.display = "block";
  }
  function hideWarning() {
    warning.style.display = "none";
  }
  function getCurrentDate() {
    let today = new Date();
    let year = today.getFullYear();
    let month = (today.getMonth() + 1).toString().padStart(2, "0");
    let day = today.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  function daysBetweenDates(date1, date2) {
    // Parse the dates using the Date constructor
    let d1 = new Date(date1);
    let d2 = new Date(date2);

    // Calculate the time difference in milliseconds
    let timeDifference = d2 - d1;

    // Convert time difference from milliseconds to days
    let daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    return daysDifference;
  }

  function calculateTotalExpenditure(BMR, activity, deficit) {
    const ABAValue = BMR * 0.1875;
    const delt = 0.9;
    const tot = BMR + ABAValue * (1.0 + (delt * activity) / 5);
    const defTEF = (tot - deficit) * 0.1;
    return Math.trunc(tot - deficit + defTEF);
  }

  function handleIntakePlan() {}
});
